// 正式环境配置
module.exports = {
  baseUrl: 'https://web.ddzuwu.com', // 项目地址
  baseApi: 'https://api-smart.ddzuwu.com' // 正式api请求地址
}
